// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zL8U","type":"styles_type__Njii3","choices":"styles_choices__LCsOl"};